var map = {
	"./Condizioni d'uso licenza_ AI-go Studio Full+Lite_ApprovazioneWeb_v1.5_set25.pdf": 1254,
	"./WHATSNEW.pdf": 4931,
	"./WHATSNEW_IT.pdf": 8085,
	"./ai-go-studio-end-user-manual.pdf": 3905,
	"./ai-go-studio-manuale-utente.pdf": 6088
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3254;